import Vue from 'vue';
import VueRouter from 'vue-router';
import VueStore from '@/store';
import { env } from '@/helpers/env';

import {
  HOME,
  LOGIN,
  START,
  DOMAIN_REGISTER,
  REGISTER_CONFIRMATION,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  DELETE_ACCOUNT,
  ORDER,
  SUMMARY,
  CUSTOM_SUMMARY,
  CONTACT_FORM,
  THANK_YOU,
  ACTIONS,
  ACTION,
  TEAMS,
} from '@/router/routes.names';

import Login from '@/views/Login';
import Start from '@/views/Start';
import Order from '@/views/Order';
import Summary from '@/views/Summary';
import CustomSummary from '@/views/CustomSummary';
import ContactForm from '@/views/ContactForm';
import DeleteAccount from '@/views/DeleteAccount';
import ThankYou from '@/views/ThankYou';

const DomainRegister = () => import(/* webpackChunkName: "auth" */ '@/views/DomainRegister');
const RegisterConfirmation = () => import(/* webpackChunkName: "auth" */ '@/views/RegisterConfirmation');
const ForgotPassword = () => import(/* webpackChunkName: "auth" */ '@/views/ForgotPassword');
const ResetPassword = () => import(/* webpackChunkName: "auth" */ '@/views/ResetPassword');
const Teams = () => import(/* webpackChunkName: "teams" */ '@/views/Teams');
const Actions = () => import(/* webpackChunkName: "actions" */ '@/views/Actions');
const Action = () => import(/* webpackChunkName: "actions" */ '@/views/Action');

Vue.use(VueRouter);

const authenticated = () => VueStore.getters['auth/isLogged'];

const ifNotAuthenticated = (to, from, next) => {
  if (!authenticated()) {
    next();
  } else {
    next({ name: START });
  }
};

const ifAuthenticated = (to, from, next) => {
  if (authenticated()) {
    next();
  } else {
    next({ name: LOGIN });
  }
};

const checkRoute = (routeName, from, next) => {
  if (authenticated()) {
    if (typeof routeName === 'string') {
      if (from.name === routeName) next();
      else next({ name: START });
    } else {
      let flag = 0;
      routeName.forEach((el) => {
        if (from.name === el) {
          flag = 1;
          next();
        }
      });
      if (flag === 0) next({ name: START });
    }
  } else next({ name: LOGIN });
};

const routes = [
  {
    path: '/',
    redirect: {
      name: START,
    },
    name: HOME,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/login',
    name: LOGIN,
    component: Login,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/domain/register',
    name: DOMAIN_REGISTER,
    component: DomainRegister,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/register/confirmation',
    name: REGISTER_CONFIRMATION,
    component: RegisterConfirmation,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/forgot-password',
    name: FORGOT_PASSWORD,
    component: ForgotPassword,
  },
  {
    path: '/reset/:token',
    name: RESET_PASSWORD,
    component: ResetPassword,
  },
  {
    path: '/start',
    name: START,
    component: Start,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/order/new/:categoryId?/:subcategoryId?',
    name: ORDER,
    component: Order,
  },
  {
    path: '/summary/',
    name: SUMMARY,
    component: Summary,
    beforeEnter: (to, from, next) => {
      checkRoute([ORDER, CONTACT_FORM], from, next);
    },
  },
  {
    path: '/summary/custom',
    name: CUSTOM_SUMMARY,
    component: CustomSummary,
    beforeEnter: (to, from, next) => {
      checkRoute([ORDER, START, CONTACT_FORM], from, next);
    },
  },
  {
    path: '/contact/',
    name: CONTACT_FORM,
    component: ContactForm,
    beforeEnter: (to, from, next) => {
      checkRoute([SUMMARY, CUSTOM_SUMMARY], from, next);
    },
  },
  {
    path: '/thank-you/',
    name: THANK_YOU,
    component: ThankYou,
    beforeEnter: (to, from, next) => {
      checkRoute(CONTACT_FORM, from, next);
    },
  },
  {
    path: '/delete/:token',
    name: DELETE_ACCOUNT,
    component: DeleteAccount,
  },
  {
    path: '/actions',
    name: ACTIONS,
    component: Actions,
  },
  {
    path: '/actions/:id',
    name: ACTION,
    component: Action,
    beforeEnter: (to, from, next) => {
      checkRoute([ACTIONS], from, next);
    },
  },
  {
    path: '/teams',
    name: TEAMS,
    component: Teams,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: env.BASE_URL,
  routes,
});

export default router;
